import React, { useState, useEffect } from "react";

const KEYFRAME_ID = "__refresh_icon_spin__";

const injectKeyframes = () => {
  if (document.getElementById(KEYFRAME_ID)) return;
  const style = document.createElement("style");
  style.id = KEYFRAME_ID;
  style.innerHTML = `
    @keyframes refreshIconSpin {
      from { transform: rotate(0deg); }
      to   { transform: rotate(-360deg); }
    }
  `;
  document.head.appendChild(style);
};

const RefreshIcon = ({ onClick, style: externalStyle, ...rest }) => {
  const [spinning, setSpinning] = useState(false);

  useEffect(() => {
    injectKeyframes();
  }, []);

  const handleClick = (e) => {
    setSpinning(false);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setSpinning(true);
        setTimeout(() => setSpinning(false), 700);
      });
    });

    if (onClick) onClick(e);
  };

  const spinStyle = spinning
    ? {
        animation: "refreshIconSpin 0.7s linear",
        display: "inline-block",
        transformOrigin: "center",
      }
    : {
        display: "inline-block",
        transformOrigin: "center",
      };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      onClick={handleClick}
      style={{ cursor: "pointer", ...spinStyle, ...externalStyle }}
      {...rest}
    >
      <path
        d="M14 16H19V21M10 8H5.00003V3M19.418 9.003C18.8574 7.61519 17.9186 6.41251 16.7084 5.53166C15.4983 4.65082 14.0653 4.12714 12.5723 4.02016C11.0793 3.91318 9.5863 4.22718 8.26291 4.92648C6.93952 5.62577 5.83886 6.68231 5.08603 7.976M4.58203 14.997C5.14283 16.3846 6.0816 17.587 7.29166 18.4676C8.50172 19.3483 9.93455 19.8718 11.4273 19.9788C12.9201 20.0858 14.4129 19.7719 15.7362 19.0728C17.0595 18.3737 18.1601 17.3174 18.913 16.024"
        stroke="#212121"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RefreshIcon;
